import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const MeeraMenezes = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Meera Menezes"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Meera-M_-photo-copyright-Parthiv-Shah-1.jpg"
                bio="Meera Menezes is an art writer and independent curator. She has written extensively on modern and contemporary Indian art over the past three decades and is the author of V.S. Gaitonde: Sonata of Solitude. She anchors the arts magazine, Art India, in Delhi and is a regular contributor to the international arts publication Artforum. Her most recent curatorial projects include Legal Alien (2022), Yuva Sumbhava (2022), Phantom Limb (2019) as well as Shadow Lines: Experiments with Light, Line and Liminality (2019), which brought together several generations of Indian artists exploring abstraction. Menezes has done her Masters in German Studies from Jawaharlal Nehru University, Delhi, and has worked as a TV journalist and producer at the South Asia Bureau of ARD, Germany’s largest public service broadcaster, for over a decade."
            />
        </>
    );
};

export default MeeraMenezes;